import styled from '@emotion/styled';
import React, { useState, useEffect } from 'react';
import { TopDisplay, FilterDropDown } from '../../../ui-components';
import { default as ApplicantReport } from './ApplicantReport';
import { default as ApplicationReport } from './ApplicationReport';
import { default as InterviewReport } from './InterviewReport';
import { default as ApplicantDetailsReport } from './ApplicantDetailsReport';
import { default as PaymentReport } from './PaymentReport';
import { default as InductionReport } from './InductionReport';
import { default as DeactivationReport } from './DeactivationReport';
import MembershipReport from './MembershipReport';


// Define the types for reportViews
interface ReportView {
  view: React.ReactNode;
  title: string;
  id: number;
}

const reportTypes = [
  { id: 1, name: 'Application Report' },
  { id: 2, name: 'Applicant Report' },
  { id: 3, name: 'Payment Report' },
  { id: 4, name: 'Deactivation Report' },
  { id: 5, name: 'Applicant Details Report' },
  { id: 6, name: 'Membership Report' },


];

const reportViews: ReportView[] = [
  { view: <ApplicationReport />, title: 'Application Report', id: 1 },
  { view: <ApplicantReport setRouteName={() => {}} />, title: 'Applicant Report', id: 2 },
  { view: <InterviewReport />, title: 'Interview Report', id: 3 },
  { view: <PaymentReport setRouteName={() => {}} />, title: 'Payment Report', id: 3 },
  { view: <InductionReport />, title: 'Induction Report', id: 7 },
  { view: <DeactivationReport />, title: 'Report Of Deactivated Applicant', id: 4 },
  { view: <ApplicantDetailsReport setRouteName={() => {}}  />, title: 'Aplicant Details Report(Select Route /Date Range to see data)', id: 5 },
  { view: <MembershipReport setRouteName={() => {}}  />, title: 'Aplicant membership Repor', id: 6 },


];


const Reports = () => {
  const [currentReports, setCurrentReport] = useState<ReportView>(reportViews[0]);

  const handleReportChange = (selectedReport: { id: number }) => {
    const report = reportViews.find((r) => r.id === selectedReport.id);
    if (report) {
      setCurrentReport(report);
    }
  };

  return (
    <Wrapper>
      <TopDisplay
        title="Report"
        subTitle={`Reports / ${currentReports?.title}`}
        Btn={<FilterDropDown text="Select Report Type" bg="#0A3922" color="#fff" options={reportTypes} onChange={handleReportChange} replace={true} />}
      />
      {currentReports?.view}
    </Wrapper>
  );
};

export default Reports;

const Wrapper = styled.div`
  padding: 0px 20px;
  flex-direction: column;
  gap: 15px;
  & > * {
    flex: 1;
  }
`;
